import { Box, DialogActions, DialogContent } from '@mui/material';
import { DialogDefault, ThemeButton, ThemeTypography } from 'DesignSystem';
import React, { FC, useState } from 'react';
import { IDefaultDialogProps } from 'types/dialog.types';
import { IBaseClusterSite } from 'FeatureModules/Site/types/site.types';
import useSiteMutations from '../../hooks/useSiteMutations';
import FlexBox from 'Components/FlexBox';

interface IDeleteSiteClusterDialogProps extends IDefaultDialogProps {
  siteCluster: IBaseClusterSite;
}

const DeleteSiteClusterDialog: FC<IDeleteSiteClusterDialogProps> = ({
  open,
  siteCluster,
  onClose,
}) => {
  const { deleteSite } = useSiteMutations();

  const [loadingDeleteAllSites, setDeleteAllSitesLoading] = useState(false);
  const [loadingDeleteOnlyCluster, setDeleteOnlyClusterLoading] = useState(false);

  const handleDeleteAllSites = async () => {
    setDeleteAllSitesLoading(true);
    await deleteSite({ variables: { id: siteCluster.id, deleteSitesFromCluster: true } });
    onClose?.();
  };

  const handleDeleteOnlyCluster = async () => {
    setDeleteOnlyClusterLoading(true);
    await deleteSite({ variables: { id: siteCluster.id, deleteSitesFromCluster: false } });
    onClose?.();
  };

  return (
    <DialogDefault
      open={open}
      title="Delete site cluster"
      itemTitle={siteCluster.title}
      fullWidth
      maxWidth="md"
      onClose={onClose}
    >
      <DialogContent>
        <Box mb={1}>
          <ThemeTypography variant="BODY_LARGE">
            You are about to delete the site cluster. You can choose if you want to delete all sites
            of the cluster or keep them in your account. All data will be lost and you will not be
            able to recover this item.
          </ThemeTypography>
        </Box>
      </DialogContent>
      <DialogActions>
        <FlexBox width="100%" justifyContent="space-between">
          <ThemeButton
            color="BLUE_ICE"
            size="large"
            data-testid="alert-dialog-cancel"
            onClick={onClose}
          >
            Cancel
          </ThemeButton>
          <FlexBox gap={1}>
            <ThemeButton
              loading={loadingDeleteAllSites}
              onClick={handleDeleteAllSites}
              color="PRIMARY"
              size="large"
              autoFocus
              data-testid="delete-cluster-and-all-sites-button"
            >
              Delete cluster and all sites
            </ThemeButton>
            <ThemeButton
              loading={loadingDeleteOnlyCluster}
              onClick={handleDeleteOnlyCluster}
              color="PRIMARY"
              size="large"
              autoFocus
              data-testid="delete-cluster-and-keep-sites-button"
            >
              Delete cluster and keep sites
            </ThemeButton>
          </FlexBox>
        </FlexBox>
      </DialogActions>
    </DialogDefault>
  );
};

export default DeleteSiteClusterDialog;
